import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
    ChatPageToScreenProps,
    DrawState,
    FrameShapeProps,
    ImageShapeProps,
    PageToScreenProps
} from "../types/draw.types";

const initialState: DrawState = {
    currentTaskFrameIds: null,
    screenPosition: null,
    currentStepId: '',
    chatScreenPosition: null,
    currentImageShape: null,
    currentChatOn: null
};

export const drawSlice = createSlice({
    name: 'draw',
    initialState,
    reducers: {
        setCurrentTaskFrameIds: (state, action: PayloadAction<{[key: string]: FrameShapeProps} | null>) => {
            state.currentTaskFrameIds = action.payload;
        },
        setScreenPosition: (state, action: PayloadAction<PageToScreenProps | null>) => {
            state.screenPosition = action.payload;
        },
        setChatScreenPosition: (state, action: PayloadAction<ChatPageToScreenProps | null>) => {
            state.chatScreenPosition = action.payload;
        },
        setCurrentStepId: (state, action: PayloadAction<string>) => {
            state.currentStepId = action.payload;
        },
        setCurrentImageShape: (state, action: PayloadAction<ImageShapeProps | null>) => {
            state.currentImageShape = action.payload;
        },
        setCurrentChatOn: (state, action: PayloadAction<{type: string, img: string} | null>) => {
            state.currentChatOn = action.payload;
        }
    }
});

export const {
    setCurrentTaskFrameIds,
    setScreenPosition,
    setCurrentStepId,
    setChatScreenPosition,
    setCurrentImageShape,
    setCurrentChatOn
} = drawSlice.actions;

export default drawSlice.reducer;